import { createAsyncThunk } from '@reduxjs/toolkit';
import ScenarioApi from 'api/ScenariosAPI';
import { PrivateScenario } from 'models/privateScenario';

export const fetchAllPrivateScenario = createAsyncThunk<PrivateScenario[]>(
  'privateScenario/fetchAll',
  async () => ScenarioApi.getScenariosPrivate()
);
